const STRING_FILTER_TYPES = {
  select: 'Select',
  startsWith: 'Starts With',
  endsWith: 'Ends With',
  contains: 'Contains',
  exactMatch: 'Exact Match',
  advancedFilters: 'Advanced Filters'
};

const DATE_FILTER_TYPES = {
  afterDate: '> After Date',
  afterOrOnDate: '≥ On OR After Date',
  onDate: '= On Date',
  onOrBeforeDate: '≤ On OR Before Date',
  beforeDate: '< Before Date',
  dateRange: '[] Date Range',
  daysAgo: '# of Days Ago'
};

const NUMBER_FILTER_TYPES = {
  greaterThan: 'Greater Than',
  greaterThanOrEqualsTo: 'Greater Than Or Equals To',
  equalsTo: 'Equals To',
  lessThanOrEqualsTo: 'Less Than Or Equals To',
  lessThan: 'Less Than',
  numberRange: 'Range'
};

export const ALL_FILTERS = {
  none: 'No filter',
  ...STRING_FILTER_TYPES,
  ...DATE_FILTER_TYPES,
  ...NUMBER_FILTER_TYPES
};

export const filterNames = Object.keys(ALL_FILTERS);
export const filterTexts = Object.keys(ALL_FILTERS);
